// src/components/create-project/utils/constants.ts
import { 
  Globe, Cpu, Smartphone, Server, 
  FileText, Image, Video, Music,
  Layout, LayoutGrid, ShoppingBag, ImageIcon 
} from 'lucide-react';

export const STEPS = [
  { title: 'Project Info', description: 'Name and describe your project' },
  { title: 'Use Cases', description: 'Select your project\'s use cases' },
  { title: 'Content Types', description: 'Choose content types to manage' },
  { title: 'Structure', description: 'Define content organization' },
  { title: 'Review', description: 'Review your selections' },
];

export const USE_CASES = [
  { value: 'Website', icon: Globe, description: 'Create and manage website content' },
  { value: 'IoT', icon: Cpu, description: 'Manage IoT device data and configurations' },
  { value: 'Mobile Application', icon: Smartphone, description: 'Content for mobile apps' },
  { value: 'API-based Service', icon: Server, description: 'Serve content via APIs' },
];

export const CONTENT_TYPES = [
  { value: 'Text', icon: FileText, description: 'Articles, posts, and documents' },
  { value: 'Images', icon: Image, description: 'Photos, illustrations, and graphics' },
  { value: 'Videos', icon: Video, description: 'Video content and streams' },
  { value: 'Audio', icon: Music, description: 'Music, podcasts, and audio files' },
];

export const CONTENT_STRUCTURES = [
  { value: 'Single pages', icon: Layout, description: 'Standalone pages' },
  { value: 'Multi-page structures', icon: LayoutGrid, description: 'Blogs, documentation' },
  { value: 'Product catalogs', icon: ShoppingBag, description: 'E-commerce listings' },
  { value: 'Portfolios', icon: ImageIcon, description: 'Showcase work' },
];